export default [
  '+ {clickId}',
  '+ {campaignId}',
  '+ {campaignName}',
  '+ {campaignNumber}',
  '+ {trafficSourceId}',
  '+ {trafficSourceName}',
  '+ {landingId}',
  '+ {landingName}',
  '+ {landingNumber}',
  '+ {trafficSourceNumber}',
  '+ {affiliateNetworkNumber}',
  '+ {flowNumber}',
  '+ {offerId}',
  '+ {offerName}',
  '+ {deviceType}',
  '+ {deviceVendor}',
  '+ {deviceModel}',
  '+ {browser}',
  '+ {browserVersion}',
  '+ {os}',
  '+ {osVersion}',
  '+ {country}',
  '+ {countryCode}',
  '+ {city}',
  '+ {region}',
  '+ {isp}',
  '+ {userAgent}',
  '+ {ip}',
  '+ {custom1}',
  '+ {custom2}',
  '+ {customN}',
  '+ {trackingDomain}',
  '+ {referrerDomain}',
  '+ {lang}',
  '+ {connectionType}',
  '+ {mobileCarrier}',
  '+ {landingSignature}'
];